import type { StockValuationItem } from '../types/report';

export const stockValuationRowKey = (item: StockValuationItem): string =>
  String(item.item_id);

export interface StockValuationTotals {
  count: number;
  qtyOnHand: number;
  totalValue: number;
}

export const computeStockValuationTotals = (
  rows: StockValuationItem[]
): StockValuationTotals => {
  let qtyOnHand = 0;
  let totalValue = 0;
  for (const row of rows) {
    qtyOnHand += parseFloat(row.qty_on_hand) || 0;
    totalValue += parseFloat(row.total_value) || 0;
  }
  return {
    count: rows.length,
    qtyOnHand,
    totalValue,
  };
};
